import { CollectionEntity } from "@busy-human/gearbox";
import { Destinations } from "../Destinations/index.js";
import { z } from "zod";
export var Builders;
(function (Builders) {
    Builders.AgeGroupSchema = z.union([z.literal("teen"), z.literal("parent")]);
    Builders.GenderSchema = z.union([z.literal("male"), z.literal("female")]);
    Builders.GroupSchema = z.string().refine((arg) => {
        if (!arg.includes("_") || (arg.indexOf("_") !== arg.lastIndexOf("_")))
            return false;
        const [group, gender] = arg.split("_");
        const [groupRes, genderRes] = [Builders.AgeGroupSchema.safeParse(group), Builders.GenderSchema.safeParse(gender)];
        if (!groupRes.success || !genderRes.success)
            return false;
        return true;
    });
    function dateToBirthdate(date) {
        const str = date.toISOString();
        return str.substring(str.indexOf('T') - 10, str.indexOf('T'));
    }
    Builders.dateToBirthdate = dateToBirthdate;
    Builders.AddressSchema = z.object({
        address1: z.string().default(""),
        address2: z.string().default(""),
        zipCode: z.string().default(""),
        state: z.string().default(""),
        country: z.string().default(""),
        city: z.string().default("")
    }).default({});
    let TSHIRT;
    (function (TSHIRT) {
        TSHIRT["XSMALL"] = "X-Small";
        TSHIRT["SMALL"] = "Small";
        TSHIRT["MEDIUM"] = "Medium";
        TSHIRT["LARGE"] = "Large";
        TSHIRT["XLARGE"] = "X-Large";
        TSHIRT["XLARGE_2"] = "2XL";
        TSHIRT["XLARGE_3"] = "3XL";
        TSHIRT["XLARGE_4"] = "4XL";
    })(TSHIRT = Builders.TSHIRT || (Builders.TSHIRT = {}));
    Builders.TShirtSchema = z.nativeEnum(TSHIRT);
    let GUARDIANRELATIONSHIP;
    (function (GUARDIANRELATIONSHIP) {
        GUARDIANRELATIONSHIP["Parent"] = "Parent";
        GUARDIANRELATIONSHIP["Grandparent"] = "Grandparent";
        GUARDIANRELATIONSHIP["AuntUncle"] = "Aunt/Uncle";
        GUARDIANRELATIONSHIP["Guardian"] = "Parent";
        GUARDIANRELATIONSHIP["ResponsibleParty"] = "Responsible Party";
    })(GUARDIANRELATIONSHIP = Builders.GUARDIANRELATIONSHIP || (Builders.GUARDIANRELATIONSHIP = {}));
    Builders.GuardianRelationshipSchema = z.nativeEnum(GUARDIANRELATIONSHIP);
    let MARRIAGESTATUS;
    (function (MARRIAGESTATUS) {
        MARRIAGESTATUS["Married"] = "Married";
        MARRIAGESTATUS["Divorced"] = "Divorced";
        MARRIAGESTATUS["Single"] = "Single";
        MARRIAGESTATUS["Other"] = "Other";
    })(MARRIAGESTATUS = Builders.MARRIAGESTATUS || (Builders.MARRIAGESTATUS = {}));
    Builders.MaritalStatusSchema = z.nativeEnum(MARRIAGESTATUS);
    //export enum CUSTODY{
    //    soleCustody = "I Have Sole Custody",
    //    jointCustody = "Joint Custody"
    //}
    //export const CustodySchema = z.nativeEnum(CUSTODY);
    Builders.GuardianSchema = z.object({
        relationship: Builders.GuardianRelationshipSchema.nullable().default(null),
        name: z.string().trim().default(""),
        email: z.string().trim().default(""),
        phone: z.string().trim().default(""),
        occupation: z.string().trim().default(""),
        company: z.string().trim().default(""),
        jobTitle: z.string().trim().default(""),
        hasCustodyAgreement: z.boolean().nullable().default(null),
        custodyAgreement: z.string().trim().optional(),
    }).default({});
    let BuilderType;
    (function (BuilderType) {
        /** TODO: In the 2024 - 2025 season, change "builder" to "teenBuilder" */
        BuilderType["Builder"] = "builder";
        BuilderType["ParentBuilder"] = "parentBuilder";
        BuilderType["AtHomeParent"] = "atHomeParent";
        BuilderType["TripLeader"] = "tripLeader";
        BuilderType["LocalCoordinator"] = "localCoordinator";
    })(BuilderType = Builders.BuilderType || (Builders.BuilderType = {}));
    Builders.BuilderTypeSchema = z.nativeEnum(BuilderType);
    Builders.EmergencyContactSchema = z.object({
        name: z.string().trim().default(""),
        relationship: z.string().trim().default(""),
        homePhone: z.string().trim().default(""),
        workPhone: z.string().trim().default(""),
        mobilePhone: z.string().trim().default(""),
        email: z.string().trim().default(""),
        info: z.string().trim().default("")
    }).default({});
    Builders.GroupMap = {
        "parent_female": "Parent Female",
        "parent_male": "Parent Male",
        "teen_female": "Teen Female",
        "teen_male": "Teen Male",
    };
    function MakeGroupReadable(group) {
        return Builders.GroupMap[group];
    }
    Builders.MakeGroupReadable = MakeGroupReadable;
    Builders.ModelSchema = z.object({
        // Contact Information
        userId: z.string().default(""),
        subUserId: z.string().optional(),
        name: z.object({
            fullName: z.string().trim().optional(),
            firstName: z.string().trim().default(""),
            lastName: z.string().trim().default(""),
            preferredName: z.string().trim().optional()
        }).transform(a => {
            // Make sure fullname is always 'firstname lastname'
            if (a.firstName && a.lastName)
                a.fullName = `${a.firstName} ${a.lastName}`;
            return a;
        }).default({}),
        zohoContactID: z.string().trim().optional(),
        email: z.string().trim().email().optional(),
        username: z.string().trim().nullish(),
        subUsername: z.string().trim().nullish(),
        isDeleted: z.boolean().optional(),
        previousParent: z.boolean().optional().default(false),
        birthday: z.string().default(""),
        gender: Builders.GenderSchema.default("male"),
        builderType: Builders.BuilderTypeSchema.default(BuilderType.Builder),
        phoneNumber: z.string().default(""),
        whatsapp: z.string().nullable().default(null),
        // Guardians
        guardianInfo: z.tuple([Builders.GuardianSchema.nullable(), Builders.GuardianSchema.nullable()]).default([null, null]),
        // Address
        address: Builders.AddressSchema,
        sameAsMailing: z.boolean().default(false),
        mailingAddress: Builders.AddressSchema.optional().nullable().default(null),
        // Personal
        shirtSize: Builders.TShirtSchema.nullable().default(null),
        instagram: z.string().nullable().default(null),
        facebook: z.string().nullable().default(null),
        highSchool: z.string().nullable().default(null),
        university: z.string().nullable().default(null),
        profession: z.string().nullable().default(null),
        employer: z.string().nullable().default(null),
        maritalStatus: z.string().nullable().default(null),
        spouseName: z.string().nullable().default(null),
        // Emergency Contacts
        emergencyContacts: z.tuple([Builders.EmergencyContactSchema.nullable(), Builders.EmergencyContactSchema.nullable()]).default([null, null]),
        // Bishop info
        bishopInfo: z.object({
            isLDS: z.boolean().default(false),
            name: z.string().nullable().default(null),
            phone: z.string().nullable().default(null),
            email: z.string().nullable().default(null),
            stake: z.string().nullable().default(null),
            ward: z.string().nullable().default(null)
        }).default({}),
        paymentLinkId: z.string().optional(),
        zohoId: z.string().nullable().default(null),
        blacklisted: z.boolean().optional()
    }).default({});
    // ! Moved to its own collection
    // healthInformation?: HealthInfo,
    // ! Moved to BuilderRecord
    // policies: Policies
    // policiesTimeStamps: PoliciesTimeStamps,
    // parentTrainingDate?: ISOTimestamp
    // parentBuilderPacket?: ParentBuilderPacket
    // atHomeBuilderPacket?: BuilderPacket
    // builderTypeDetails: BuilderTypeDetails // Move elsewhere
    // backgroundCheckTime?: ISOTimestamp,
    // builderFlightInfo?: BuilderFlightInfo
    // contactInfo: Status,
    // prefStatus: Status,
    // preferences: TripSlotPreference[] // TripSlot Id[]
    // policy: Status
    // registrationState: RegistrationState
    // peak15ContactID?: string
    // peak15HouseholdID?: string
    // peak15GuestID?: string
    // peak15AttendedParentTraining?: boolean
    // builderChecklist?: BuilderChecklist
    // builderPacket?: BuilderPacket
    // notarizedAuthorization?: BuilderPacket
    // userPicture?: BuilderPacket,
    // userVisa?: BuilderPacket,
    // userAffidavit?: BuilderPacket,
    // immunizationRecord?: BuilderPacket,
    // insuranceCard?: BuilderPacket,
    // healthForm?: BuilderPacket,
    // groupMeJoined?: boolean
    // readyForDoctorNoteUpload?: boolean
    // maybeParent?: boolean
    function Default() {
        return Builders.ModelSchema.parse({});
    }
    Builders.Default = Default;
    function Validate(obj) {
        return Builders.ModelSchema.parse(obj);
    }
    Builders.Validate = Validate;
    const BEGINNING_OF_TIME = 1970;
    /**
     *
     * @param birthday Birthday, date compatible
     * @param date Date to reference from
     * @returns Age of builder in Years
     */
    function GetBuilderAge(birthday, date) {
        const ms = date?.getTime() || Date.now();
        const dif = ms - new Date(birthday).getTime();
        const age = new Date(dif);
        const years = Math.floor(age.getUTCFullYear() - BEGINNING_OF_TIME);
        return years;
    }
    Builders.GetBuilderAge = GetBuilderAge;
    /** Age at which >= is considered an adult in HXP */
    Builders.AdultAge = 20;
    /** Ages where >= is allowed to go as a parent */
    Builders.MinimumAgeForAdult = 35;
    /** Minimum age for builder, where >= is allowed to go on trips */
    Builders.MinimumAge = 14;
    function IsBuilderAdult(builder, date) {
        const years = GetBuilderAge(builder.birthday, date);
        return years >= Builders.AdultAge;
    }
    Builders.IsBuilderAdult = IsBuilderAdult;
    /** Is a builder able to go on any trips at all in HXP */
    function IsBuilderAllowed(builder, date) {
        const years = GetBuilderAge(builder.birthday, date);
        // Subtracting 1 from minimum age as potentially some people will be old enough
        return years >= Builders.MinimumAge - 1 && (years < Builders.AdultAge || years >= Builders.MinimumAgeForAdult);
    }
    Builders.IsBuilderAllowed = IsBuilderAllowed;
    /** Returns the builder's group */
    function GetBuilderGroup(builder, date) {
        if (!builder.gender)
            throw new Error("Builder does not have gender assigned");
        if (!IsBuilderAdult(builder, date))
            return `${'teen'}_${builder.gender}`;
        else
            return `${'parent'}_${builder.gender}`;
    }
    Builders.GetBuilderGroup = GetBuilderGroup;
    /** Returns true if the builder is able to join a particular slot */
    function IsBuilderAllowedInSlot(builder, slot, destination, checkGroup = true) {
        const years = GetBuilderAge(builder.birthday, new Date(slot.startDate));
        if (years < Builders.MinimumAgeForAdult && years >= Builders.AdultAge)
            return false;
        if (years < Destinations.GetDestinationMinimumAge(destination))
            return false;
        if (years < Builders.AdultAge && years > Destinations.GetDestinationMaximumAge(destination))
            return false;
        if (checkGroup) {
            const builderGroup = GetBuilderGroup(builder, new Date(slot.startDate));
            if (slot.groups?.[builderGroup]) {
                const slotGroup = slot.groups[builderGroup];
                if (!(slotGroup?.max && (slotGroup.max - (slotGroup.registered || 0) > 0)))
                    return false;
            }
            else {
                return false;
            }
        }
        return true;
    }
    Builders.IsBuilderAllowedInSlot = IsBuilderAllowedInSlot;
    // ? Isn't this the same as IsBuilderAllowedInSlot, but with checkGroup (the last arg) being false? Why?
    function IsBuilderEligbleForSlot(builder, slot, destination) {
        const years = GetBuilderAge(builder.birthday, new Date(slot.startDate));
        if (years < Builders.MinimumAgeForAdult && years >= Builders.AdultAge)
            return false;
        if (years < Destinations.GetDestinationMinimumAge(destination))
            return false;
        if (years < Builders.AdultAge && years > Destinations.GetDestinationMaximumAge(destination))
            return false;
        return true;
    }
    Builders.IsBuilderEligbleForSlot = IsBuilderEligbleForSlot;
    /**
     * Gets the first name and last name for a builder
     * @param builder
     * @returns firstname and lastname in an object
     */
    function BuilderFirstnameLastname(builder) {
        // const split = builder.name.split(' ');
        // const firstname = split[0];
        // const lastname = split[split.length - 1];
        const { firstName } = builder.name;
        const { lastName } = builder.name;
        return { firstName, lastName };
    }
    Builders.BuilderFirstnameLastname = BuilderFirstnameLastname;
    // ! Moved to BuilderHealthRecord
    // export function HealthInfoDefaults(){
    //     const HealthInfo = {
    //         // TODO: Fix this
    //         section_a:{
    //             fullName: '',
    //             dob: '',
    //             builderSignature: '',
    //             builderDate: '',
    //         },
    //         section_b:{
    //             fullName: '',
    //             dob: '',
    //             builderSignature: '',
    //             builderDate: '',
    //         },
    //         HIPPA_a:{
    //             fullName: '',
    //             dob: '',
    //             builderSignature: '',
    //             builderDate: '',
    //         },
    //         HIPPA_b:{
    //             consentForRelease: false,
    //             builderSignature: '',
    //             builderDate: '',
    //             fullName: '',
    //         },
    //         section_c:{
    //             doctorsName: '',
    //             doctorsEmail: '',
    //         }
    //     };
    //     return HealthInfo;
    // }
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Default();
        }
        async getBuildersForUser(uid) {
            return (await this.subset((ref, query) => query.where('userId', '==', uid).toQuery()).fetch()).map(d => d.data());
        }
        getBuildersForUserSubset(uid) {
            return this.subset((_, query) => query.where('userId', '==', uid).toQuery());
        }
        async getAllAsMap() {
            return new Map((await this.fetchAll()).dataItems().map(b => ([b.$id, b])));
        }
    }
    Builders.CollectionClass = CollectionClass;
    Builders.Collection = new CollectionClass({ path: '/Builders' });
    async function getFirestoreId(zohoId) {
        const subset = Builders.Collection.subset(q => q.where('zohoId', '==', zohoId));
        await subset.fetch();
        return subset.size > 0 ? subset.dataItems()[0].$id : undefined;
    }
    Builders.getFirestoreId = getFirestoreId;
    async function getZohoId(firebaseId) {
        const item = await Builders.Collection.fetchData(firebaseId);
        if (item) {
            return item.zohoId || undefined;
        }
        else {
            return undefined;
        }
    }
    Builders.getZohoId = getZohoId;
})(Builders || (Builders = {}));
//# sourceMappingURL=index.js.map